/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLadder = createReactComponent("outline", "ladder", "IconLadder", [["path", { "d": "M8 3v18", "key": "svg-0" }], ["path", { "d": "M16 3v18", "key": "svg-1" }], ["path", { "d": "M8 14h8", "key": "svg-2" }], ["path", { "d": "M8 10h8", "key": "svg-3" }], ["path", { "d": "M8 6h8", "key": "svg-4" }], ["path", { "d": "M8 18h8", "key": "svg-5" }]]);

export { IconLadder as default };
//# sourceMappingURL=IconLadder.mjs.map
